/*
 * BACKEND MIGRATION TO REMOVE THIS FILE
 *
 * Temporary responsibility:
 * - Wrap the existing frontend-only Planner schedule composition hook.
 * - Convert the mixed schedule row data into backend-shaped PlannerEvent
 *   sections for UI components.
 * - Preserve the current scaffold fallback behavior while the backend Planner
 *   workspace endpoint does not exist.
 *
 * Backend replacement:
 * - Replace this hook with a single call to:
 *   GET /api/v1/planner/workspace?date=YYYY-MM-DD&timeZone=<IANA>
 * - The backend should return:
 *   { sections, generatedAt, partialErrors }
 *   where sections contain PlannerEvent objects from plannerModels.js.
 *
 * Delete this file when:
 * - The backend returns PlannerEvent sections directly.
 * - PlannerPage no longer imports usePlannerSchedule or
 *   plannerScheduleAdapter anywhere in the planner surface.
 */

import {useMemo} from 'react';
import usePlannerSchedule from './usePlannerSchedule';
import {getPlannerScaffoldSchedule} from './plannerScaffoldData';
import {
  getVisiblePlannerEventSections,
  isPlannerScheduleEmpty,
} from './plannerModels';

export default function usePlannerEventSections({
  userData,
}: Record<string, any> = {}) {
  const {
    schedule: liveSchedule,
    scheduleScope,
    isLoading,
    error,
    refresh,
    hasLoaded,
    encounterHistorySeed,
  } = usePlannerSchedule({userData});

  const isFallback = Boolean(error && isPlannerScheduleEmpty(liveSchedule));
  const schedule = isFallback ? getPlannerScaffoldSchedule() : liveSchedule;

  const sections = useMemo(
    () => getVisiblePlannerEventSections(schedule),
    [schedule],
  );

  return {
    sections,
    scheduleScope,
    isLoading,
    hasLoaded,
    error,
    isFallback,
    refresh,
    encounterHistorySeed,
  };
}
